import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css']
})
export class ErrorComponent implements OnInit {

  message: string;
  triconSupportPhoneNumberDotFormat: string = environment.triconSupportPhoneNumberDotFormat;
  triconSupportPhoneNumber: string = environment.triconSupportPhoneNumber;

  constructor(private router: Router) {
    this.message = this.router?.getCurrentNavigation()?.extras?.state?.message ?? 'Unknown Error';
   }

  ngOnInit(): void {

  }

}
